module.exports = __webpack_public_path__ + "static/2-165f3f62d21a8cc60e2e08548f2f8f26.png";